/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Comment_PlaceholderInputs */

const en_us2_engagement_comment_placeholder = /** @type {(inputs: Engagement_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what was missing or got in the way`)
};

const pt_br2_engagement_comment_placeholder = /** @type {(inputs: Engagement_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte o que faltou ou atrapalhou`)
};

const es_419_engagement_comment_placeholder = /** @type {(inputs: Engagement_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos qué faltó o qué estorbó`)
};

const pt_pt2_engagement_comment_placeholder = /** @type {(inputs: Engagement_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta-nos o que faltou ou atrapalhou`)
};

const fr_fr2_engagement_comment_placeholder = /** @type {(inputs: Engagement_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dis-nous ce qui a manqué ou t'a gêné`)
};

const de_de2_engagement_comment_placeholder = /** @type {(inputs: Engagement_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzähl uns, was gefehlt oder gestört hat`)
};

const it_it2_engagement_comment_placeholder = /** @type {(inputs: Engagement_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccontaci cosa è mancato o ti ha ostacolato`)
};

/**
* | output |
* | --- |
* | "Tell us what was missing or got in the way" |
*
* @param {Engagement_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_comment_placeholder = /** @type {((inputs?: Engagement_Comment_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Comment_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_comment_placeholder(inputs)
	if (locale === "es-419") return es_419_engagement_comment_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_comment_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_comment_placeholder(inputs)
	if (locale === "de-DE") return de_de2_engagement_comment_placeholder(inputs)
	if (locale === "it-IT") return it_it2_engagement_comment_placeholder(inputs)
	return en_us2_engagement_comment_placeholder(inputs)
});
export { engagement_comment_placeholder as "engagement.comment_placeholder" }